/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { FileError } from 'react-dropzone';
import { ExcelRenderer } from 'react-excel-renderer';
import { IFloatingFilterType } from 'ag-grid-community';

const defaultFilter = {
  include: true,
  acceptEmpty: false,
  dataType: 'string',
};

type ColDefs = {
  headerName: string;
  field: string;
  filter: string;
  suppressMenu: boolean;
  floatingFilterComponent: IFloatingFilterType;
  floatingFilterComponentParams: {
    suppressFilterButton: boolean;
  };
};
/* eslint-disable */
type RowData = {
  [key: string]: any;
};

export const createAgGridData = (rows: RowData) => {
  const colNames: string[] = rows[0];
  const rowData = rows.slice(1);
  const mappedRowData = mapRowData(colNames, rowData);
  return mappedRowData;
}
/* eslint-enable */
export const mapRowData = (colNames: string[], rowData: RowData) => {
  return rowData.map((row: any[]) => {
    const newRows: any = {};
    row.forEach((item, index) => {
      newRows[colNames[index]] = item;
    });
    return newRows;
  });
};

export const fileHandler = async(file: File) => {
  return await ExcelRenderer(
    file,
    (err: FileError, resp: { rows: any[][]; cols: [] }) => {
      if (!resp || !resp.rows) {
        return undefined;
      }
      if (err) {
        // FIXME: error feedback
        throw new Error(err.message);
      }
      return {
        rows: resp.rows,
      };
    },
  );
};
